import script from "./MyIconSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyIconSelector.vue?vue&type=script&lang=ts&setup=true"

import "./MyIconSelector.vue?vue&type=style&index=0&id=3dcdac22&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dcdac22"]])

export default __exports__